/**
 * Breadcrumb
 *
 * Questo oggetto viene utilizzato per creare un breadcrumb trail nella pagina del prodotto.
 * Si basa sui dati del prodotto e delle collezioni passati come parametri.
 *
 * @param {Object} product - I dati del prodotto passati dal tema Shopify
 * @param {Array} collections - Un array di oggetti collezione passati dal tema Shopify
 */
var Breadcrumb = function(product, collections) {
  this.product = product;
  this.collections = collections;
};

/**
 * Init
 *
 * Questo metodo viene utilizzato per inizializzare il breadcrumb trail.
 */
Breadcrumb.prototype.init = function() {
  var breadcrumb = '';
  var collection;
  //console.log(this.collections)
  // Find the collection that the product belongs to
  for (var i = 0; i < this.collections.length; i++) {
    if (this.collections[i].handle == this.product.tags[0].replace(/\s+/g, '-')) {
      collection = this.collections[i];
      break;
    }
  }

  // Build the breadcrumb trail
  breadcrumb += '<a href="/">Home</a>';
  if (collection) {
    breadcrumb += ' / <a href="https://www.medidentitalia.com/collections/' + collection.handle + '">' + collection.title + '</a>';
  }
  breadcrumb += ' / ' + this.product.title.replace(/\//g, ' ');

  // Insert the breadcrumb trail into the page
  var breadcrumbEl = document.querySelector('.breadcrumb');
  if (breadcrumbEl) {
    breadcrumbEl.innerHTML = breadcrumb;
  }
}